<template>
  <div>
    <!-- paperType 2表示心理 / 3表示人格  / 4表示团队-->
    <div class="pdt-btn">
      <div v-if="isPsyReport">
        <a class="download" @click="toPsyReport">心理报告</a>
      </div>

      <div v-if="isPerReport">
        <a class="download" @click="toPerReport">人格报告</a>
      </div>

      <div v-if="isTeamReport">
        <a class="download" @click="toTeamReport">团队报告</a>
      </div>

      <div v-if="isBehaviorReport">
        <a class="download1" @click="toBehaviorReport">胜任力报告</a>
      </div>
    </div>
    <pageOne :model="model" :score="score" :score100="score100" :isPsychology="isPsychology" :privacyType="privacyType"
      :isPersonality="isPersonality" :isTeam="isTeam" :isBehavior="isBehavior" :time="time" :info="info" :guid="guid"
      :report_type="report_type" />
    <pageTwo :isPsychology="isPsychology" :isPersonality="isPersonality" :isTeam="isTeam" :isBehavior="isBehavior"
      :behaviorResult="behaviorResult" />
    <pageThree :isPsychology="isPsychology" :isPersonality="isPersonality" :isBehavior="isBehavior" :isTeam="isTeam"
      v-if="isPsychology == true || isPersonality == true || isBehavior == true" />
    <pageFour v-if="isPsychology == true" :model="model" :name="name" :result="result" :score="score1" :name1="name1" />
    <pageFive :model="model" :result="result" :name="name" v-if="isPsychology == true" />
    <pageSix :result="result" :level2="level2" :score="score1" v-if="isPsychology == true" />
    <pageFourPer v-if="isPersonality == true" :model="model" :result1="result1" />
    <pageFivePer v-if="isPersonality == true" :model="model" :result="result" />
    <pageFourTeam v-if="isTeam == true" :model="model" :result="result" :teamDescribe="teamDescribe" />
    <pageFourBe v-if="isBehavior == true" :model="model" :level2Length="level2Length" :behaviorResult="behaviorResult"
      :beScore="beScore" />
    <pageFiveBe v-if="isBehavior == true" :model="model" :behaviorResult="behaviorResult" :beScore="beScore" />
    <div v-if="!isPdf" v-loading.fullscreen.lock="fullscreenLoading"></div>
  </div>
</template>
<script>
import pageOne from "@/views/report/three/pageOne";
import pageTwo from "@/views/report/three/pageTwo";
import pageThree from "@/views/report/three/pageThree";
import pageFour from "@/views/report/three/pageFour";
import pageFive from "@/views/report/three/pageFive";
import pageSix from "@/views/report/three/pageSix";
import pageFourPer from "@/views/report/three/personality/pageFour";
import pageFivePer from "@/views/report/three/personality/pageFive";
import pageFourTeam from "@/views/report/three/team/pageFour.vue";
import pageFourBe from "@/views/report/three/behavior/pageFour.vue";
import pageFiveBe from "@/views/report/three/behavior/pageFive.vue";
import { AssessApi } from './config/apis.js'

export default {
  components: {
    pageOne,
      pageTwo,
    pageThree,
    pageFour,
    pageFive,
    pageSix,
    pageFourPer,
    pageFivePer,
    pageFourTeam,
    pageFourBe,
    pageFiveBe,
  },
  data() {
    return {
      model: {},
      result: [],
      result1: [], //存储人格报告 A-J 的分数
      result2: [], //存储人格报告 a-j 的分数
      level2: [],
      score: "",
      name: "",
      score1: [],
      name1: [],
      info: [],
      score100: "",

      guid: "",
      level2Length: 0,
      isPsychology: false,
      isPersonality: false,
      isTeam: false,
      isBehavior: false,
      isPerReport: false, //有人格报告吗  （用来判按钮显示）
      isTeamReport: false, //有团队报告吗
      isPsyReport: false, //有心理报告吗
      isBehaviorReport: false, //有潜力测评报告吗
      paperType: [],
      teamDescribe: [],
      behaviorResult: [],
      report_time: [],
      beScore: [],
      report_type: "",
      candIds: "",
      positionIds: "",
      time: "",
      searchUrl: `//report1014.acmcoder.com/api/test/report?positionId=tixRGTE0tyK7nLK2MLCYGyCYtaSZtqxR&candId=tixRGTE0nixSHDIbGiE0tqEbMqjinyjT`,
      personalityUrl:
        "//kaosys.acmcoder.com/api/report/personality/6db440c9-303d-47af-8b2f-632a568d33af",
      teamUrl:
        "//kaosys.acmcoder.com/api/report/teamlity/6db440c9-303d-47af-8b2f-632a568d33af",
      behaviorUrl:
        "//report1014.acmcoder.com/api/test/report5?positionId=tiC7M1K0tazhnyhRMqQYGyCYtTphHqlS&candId=tiC2GalSGaGbtySbnDMYGyC2nDI2nDC1",
      privacyType: 1,

      fullscreenLoading: true,
      isPdf: false,
    };
  },
  mounted() {
    let candId = this.getUrlParam("candId");
    let positionId = this.getUrlParam("positionId");
    if (candId == null) {
      this.candIds = "tiC2GalSGaGbtySbnDMYGyC2nDI2nDC1"; //为了本地可以测试
    } else {
      this.candIds = candId;
    }
    if (positionId == null) {
      this.positionIds = "tiC7M1K0tazhnyhRMqQYGyCYtTphHqlS"; //为了
    } else {
      this.positionIds = positionId;
    }
    if (this.getUrlParam("guid")) {
      this.guid = this.getUrlParam("guid");
    }
    this.loadApi();
    if (location.hash.indexOf("pdf") > -1) {
      this.isPdf = true;
    }
  },
  methods: {
    // 判断跳转按钮
    loadPaperType(res) {
      this.paperType = res.data.paperType;
      this.guid = res.data.guid;
      // this.guid = "06358bfe-1296-45c5-aa18-dedbcdae6364";
      if (
        location.hash.indexOf("home") > -1 &&
        res.data.paperType.indexOf("3") > -1
      ) {
        this.isPerReport = true;
      }
      if (
        location.hash.indexOf("home") > -1 &&
        res.data.paperType.indexOf("4") > -1
      ) {
        this.isTeamReport = true;
      }
      if (
        location.hash.indexOf("home") > -1 &&
        res.data.paperType.indexOf("5") > -1
      ) {
        this.isBehaviorReport = true;
      }
    },
    //跳转按钮
    toPsyReport() {
      this.$router.push({ path: "/home" });
      window.location.reload();
    },
    toPerReport() {
      window.open(
        "./?guid=" + this.guid + "&candId=" + this.candIds + "#/personality"
      );
    },
    toTeamReport() {
      window.open(
        "./?guid=" + this.guid + "&candId=" + this.candIds + "#/team"
      );
    },
    toBehaviorReport() {
      window.open(
        "./?candId=" +
        this.candIds +
        "&positionId=" +
        this.positionIds +
        "#/behavior"
      );
    },

    loadApi() {
      //调用接口
      if (
        location.hash.indexOf("/pdf") > -1 ||
        location.hash.indexOf("/home") > -1
      ) {
        this.privacyType = 1
        this.loadData(); //心理
      } else if (
        location.hash.indexOf("/personality") > -1 ||
        location.hash.indexOf("/personalitypdf") > -1
      ) {
        this.privacyType = 2
        this.loadPersonalityData(); //人格
      } else if (
        location.hash.indexOf("/team") > -1 ||
        location.hash.indexOf("/teampdf") > -1
      ) {
        this.privacyType = 3
        this.loadTeamData();
      } else if (
        location.hash.indexOf("/behavior") > -1 ||
        location.hash.indexOf("/behaviorpdf") > -1
      ) {
        this.privacyType = 4
        this.loadBehaviorData(); //潜力行为
      }
    },
    //潜力行为测评
    loadBehaviorData() {
      if (location.hash.indexOf("/behaviorpdf") > -1) {
        this.behaviorUrl =
          AssessApi.behavior + "?positionId=" +
          this.positionIds +
          "&candId=" +
          this.candIds; 
      }
      else {
        this.behaviorUrl =
          AssessApi.behaviorEncryption + "?positionId=" +
          this.positionIds +
          "&candId=" +
          this.candIds;
      }
      this.isBehavior = true;
      $.get(this.behaviorUrl, (res) => {
        if (res.code) {
          this.$alert(res.message || '面试报告超过有效期！', "提示", {
            showClose: false,
            showConfirmButton: false
          })
          return
        }
        this.fullscreenLoading = false;
        this.model = res.data;
        // this.model.report_time = this.model.report_time.substring(0, 10);
        if (this.model.personalMustAns.degree != undefined) {
          this.info.push({
            name: "学历",
            value: this.model.personalMustAns.degree,
          });
        }
        if (this.model.personalMustAns.email != undefined) {
          this.info.push({
            name: "邮箱",
            value: this.model.personalMustAns.email,
          });
        }
        if (this.model.personalMustAns.mobile != undefined) {
          this.info.push({
            name: "电话",
            value: this.model.personalMustAns.mobile,
          });
        }
        if (this.model.personalMustAns.university != undefined) {
          this.info.push({
            name: "学校",
            value: this.model.personalMustAns.university,
          });
        }
        if (this.model.personalMustAns.major != undefined) {
          this.info.push({
            name: "专业",
            value: this.model.personalMustAns.major,
          });
        }
        if (this.model.personalMustAns.idcard != undefined) {
          this.info.push({
            name: "身份证号码",
            value: this.model.personalMustAns.idcard,
          });
        }
        if (this.model.personalMustAns.city != undefined) {
          this.info.push({
            name: "所在城市",
            value: this.model.personalMustAns.city,
          });
        }
        if (this.model.personalMustAns.GraduateDate != undefined) {
          this.info.push({
            name: "毕业时间",
            value: this.model.personalMustAns.GraduateDate,
          });
        }

        this.model.personalChooiseAns.map((item) => {
          if (item.title.indexOf("年龄") > -1 || item.title.indexOf("性别") > -1) { 
              if (item.title.indexOf('性别') > -1) {
                this.model.gender = item.answer
              }
              else if (item.title.indexOf('年龄') > -1) {
                this.model.age = item.answer
              }
              return
            }
          this.info.push({
            name: item.title,
            value: item.answer,
          });
        });
        this.info = this.info.slice(0, 4);
        // console.log("ee", this.info);
        this.behaviorResult = res.data.result[0];
        this.level2Length = this.behaviorResult.level2.length;
        this.beScore = this.behaviorResult.level2.map((item) => {
          return item.score;
        });
        this.score100 = this.behaviorResult.score100
      });
    },

    //团队测评
    loadTeamData() {
      if (location.hash.indexOf("/teampdf") > -1) {
        this.teamUrl =
          AssessApi.team + "/" + this.guid; 
      }
      else { 
        this.teamUrl =
          AssessApi.teamEncryption + "/" + this.guid;
      }
      this.isTeam = true;
      $.get(this.teamUrl, (res) => {
        if (res.errno) {
          this.$alert(res.errmsg || '面试报告超过有效期！', "提示", {
            showClose: false,
            showConfirmButton: false
          })
          return
        }
        this.fullscreenLoading = false;
        this.model = res.cand;

        this.time = res.report_time;
        this.report_type = res.report_type;

        if (res.personalMustAns.degree != undefined) {
          this.info.push({
            name: "学历",
            value: res.personalMustAns.degree,
          });
        }
        if (res.personalMustAns.email != undefined) {
          this.info.push({
            name: "邮箱",
            value: res.personalMustAns.email,
          });
        }
        if (res.personalMustAns.mobile != undefined) {
          this.info.push({
            name: "电话",
            value: res.personalMustAns.mobile,
          });
        }
        if (res.personalMustAns.university != undefined) {
          this.info.push({
            name: "学校",
            value: res.personalMustAns.university,
          });
        }
        if (res.personalMustAns.major != undefined) {
          this.info.push({
            name: "专业",
            value: res.personalMustAns.major,
          });
        }
        if (res.personalMustAns.idcard != undefined) {
          this.info.push({
            name: "身份证号码",
            value: res.personalMustAns.idcard,
          });
        }
        if (res.personalMustAns.city != undefined) {
          this.info.push({
            name: "所在城市",
            value: res.personalMustAns.city,
          });
        }
        if (res.personalMustAns.GraduateDate != undefined) {
          this.info.push({
            name: "毕业时间",
            value: res.personalMustAns.GraduateDate,
          });
        }
        if (res.cand.personalChooiseAns) {
          res.cand.personalChooiseAns.map((item) => {
            if (item.title.indexOf("年龄") > -1 || item.title.indexOf("性别") > -1) { 
              if (item.title.indexOf('性别') > -1) {
                this.model.gender = item.answer
              }
              else if (item.title.indexOf('年龄') > -1) {
                this.model.age = item.answer
              }
              return
            }
            this.info.push({
              name: item.title,
              value: item.answer,
            });
          });
        }

        this.info = this.info.slice(0, 4);
        // console.log("info", this.info);
        // this.model.personalChooiseAns = this.model.personalChooiseAns.filter(
        //   (item) => item.title != "年龄"
        // );
        // this.model.personalChooiseAns = this.model.personalChooiseAns.slice(
        //   0,
        //   4
        // );
        this.result = res.candPapers;
        this.teamDescribe = res.mapResult.list;
      });
    },
    //人格测评
    loadPersonalityData() {
      if (location.hash.indexOf("/personalitypdf") > -1) {
        this.personalityUrl =
          AssessApi.personality + "/" + this.guid; 
      }
      else {
        this.personalityUrl =
          AssessApi.personalityEncryption + "/" + this.guid;
      }
      this.isPersonality = true;
      $.get(this.personalityUrl, (res) => {
        if (res.errno) {
          this.$alert(res.errmsg || '面试报告超过有效期！', "提示", {
            showClose: false,
            showConfirmButton: false
          })
          return
        }
        this.fullscreenLoading = false;
        this.model = res;
        if (this.model.personalMustAns.degree != undefined) {
          this.info.push({
            name: "学历",
            value: this.model.personalMustAns.degree,
          });
        }
        if (this.model.personalMustAns.email != undefined) {
          this.info.push({
            name: "邮箱",
            value: this.model.personalMustAns.email,
          });
        }
        if (this.model.personalMustAns.mobile != undefined) {
          this.info.push({
            name: "电话",
            value: this.model.personalMustAns.mobile,
          });
        }
        if (this.model.personalMustAns.university != undefined) {
          this.info.push({
            name: "学校",
            value: this.model.personalMustAns.university,
          });
        }
        if (this.model.personalMustAns.major != undefined) {
          this.info.push({
            name: "专业",
            value: this.model.personalMustAns.major,
          });
        }
        if (this.model.personalMustAns.idcard != undefined) {
          this.info.push({
            name: "身份证号码",
            value: this.model.personalMustAns.idcard,
          });
        }
        if (this.model.personalMustAns.city != undefined) {
          this.info.push({
            name: "所在城市",
            value: this.model.personalMustAns.city,
          });
        }
        if (this.model.personalMustAns.GraduateDate != undefined) {
          this.info.push({
            name: "毕业时间",
            value: this.model.personalMustAns.GraduateDate,
          });
        }
        if (this.model.personalChooiseAns) {
          this.model.personalChooiseAns.map((item) => {
            if (item.title.indexOf("年龄") > -1 || item.title.indexOf("性别") > -1) { 
              if (item.title.indexOf('性别') > -1) {
                this.model.gender = item.answer
              }
              else if (item.title.indexOf('年龄') > -1) {
                this.model.age = item.answer
              }
              return
            }
            this.info.push({
              name: item.title,
              value: item.answer,
            });
          });
        }
        // console.log("this.info", this.info);
        this.info = this.info.slice(0, 4);

        this.result1.push(
          this.model.personalityValues.a,
          this.model.personalityValues.b,
          this.model.personalityValues.c,
          this.model.personalityValues.d,
          this.model.personalityValues.e,
          this.model.personalityValues.f,
          this.model.personalityValues.g,
          this.model.personalityValues.h,
          this.model.personalityValues.i,
          this.model.personalityValues.j
        );
        this.result2.push(
          this.model.personalityValues.A,
          this.model.personalityValues.B,
          this.model.personalityValues.C,
          this.model.personalityValues.D,
          this.model.personalityValues.E,
          this.model.personalityValues.F,
          this.model.personalityValues.G,
          this.model.personalityValues.H,
          this.model.personalityValues.I,
          this.model.personalityValues.J
        );
        this.result = this.model.personalityValues;
      });
    },
    //心理测评
    loadData() {
      if (location.hash.indexOf("/home") > -1) {
        this.searchUrl =
          AssessApi.psychometricsEncryption + "?positionId=" +
          this.positionIds +
          "&candId=" +
          this.candIds;
      }
      else {
        this.searchUrl =
          AssessApi.psychometrics + "?positionId=" +
          this.positionIds +
          "&candId=" +
          this.candIds;
      }
      this.isPsychology = true;
      $.get(this.searchUrl, (res) => {
        if (res.code) {
          this.$alert(res.message || '面试报告超过有效期！', '提示', {
            showClose: false,
            showConfirmButton: false
          })
          return
        }
        this.fullscreenLoading = false;
        this.model = res.data;
        if (this.model.personalMustAns.degree != undefined) {
          this.info.push({
            name: "学历",
            value: this.model.personalMustAns.degree,
          });
        }
        if (this.model.personalMustAns.email != undefined) {
          this.info.push({
            name: "邮箱",
            value: this.model.personalMustAns.email,
          });
        }
        if (this.model.personalMustAns.mobile != undefined) {
          this.info.push({
            name: "电话",
            value: this.model.personalMustAns.mobile,
          });
        }
        if (this.model.personalMustAns.university != undefined) {
          this.info.push({
            name: "学校",
            value: this.model.personalMustAns.university,
          });
        }
        if (this.model.personalMustAns.major != undefined) {
          this.info.push({
            name: "专业",
            value: this.model.personalMustAns.major,
          });
        }
        if (this.model.personalMustAns.idcard != undefined) {
          this.info.push({
            name: "身份证号码",
            value: this.model.personalMustAns.idcard,
          });
        }
        if (this.model.personalMustAns.city != undefined) {
          this.info.push({
            name: "所在城市",
            value: this.model.personalMustAns.city,
          });
        }
        if (this.model.personalMustAns.GraduateDate != undefined) {
          this.info.push({
            name: "毕业时间",
            value: this.model.personalMustAns.GraduateDate,
          });
        }

        this.model.personalChooiseAns.map((item) => {
          if (item.title.indexOf("年龄") > -1 || item.title.indexOf("性别") > -1) { 
              if (item.title.indexOf('性别') > -1) {
                this.model.gender = item.answer
              }
              else if (item.title.indexOf('年龄') > -1) {
                this.model.age = item.answer
              }
              return
            }
          this.info.push({
            name: item.title,
            value: item.answer,
          });
        });
        // console.log("this.info", this.info);
        this.info = this.info.slice(0, 3);

        // this.info.pop();
        // this.info.pop();
        // this.info.pop();
        // this.info.pop();
        // this.info.pop();

        if (this.model) {
          this.name = this.model.realName;
          this.score = this.model.score / 2;
          this.result = this.model.result.map((item) => {
            if (
              (item.score > 3.33 || item.score == 3.33) &&
              (item.score < 3.83 || item.score == 3.83)
            ) {
              item.score = 1;
            } else if (
              (item.score > 3.84 || item.score == 3.84) &&
              (item.score < 4.25 || item.score == 4.25)
            ) {
              item.score = 2;
            } else if (
              (item.score > 4.26 || item.score == 4.26) &&
              (item.score < 4.99 || item.score == 4.99)
            ) {
              item.score = 3;
            } else if (
              (item.score > 5 || item.score == 5) &&
              (item.score < 6 || item.score == 6)
            ) {
              item.score = 4;
            } else if (
              (item.score > 6.01 || item.score == 6.01) &&
              (item.score < 6.61 || item.score == 6.61)
            ) {
              item.score = 5;
            } else if (
              (item.score > 6.62 || item.score == 6.62) &&
              (item.score < 7.24 || item.score == 7.24)
            ) {
              item.score = 6;
            } else if (
              (item.score > 7.25 || item.score == 7.25) &&
              (item.score < 8.32 || item.score == 8.32)
            ) {
              item.score = 7;
            } else if (
              (item.score > 8.33 || item.score == 8.33) &&
              (item.score < 9.07 || item.score == 9.07)
            ) {
              item.score = 8;
            } else if (
              (item.score > 9.08 || item.score == 9.08) &&
              (item.score < 9.49 || item.score == 9.49)
            ) {
              item.score = 9;
            } else if (
              (item.score > 9.5 || item.score == 9.5) &&
              (item.score < 10 || item.score == 10)
            ) {
              item.score = 10;
            }
            this.score1.push(item.score);
            this.name1.push(item.name);
            return item;
          });
          this.result.map((item, index) => {
            item.level2.map((child, index) => {
              this.level2.push(child);
              return child;
            });
          });
        }
        this.loadPaperType(res);
      });
    },
    //获取url的🔧
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 800px;
  height: auto;
  margin: 0px auto;
  background-color: white;

  .pdt-btn {
    position: fixed;
    right: 20px;
    top: 220px;

    .download {
      padding: 40px 20px;
      background: #333;
      color: #fff;
      display: block;
      margin-bottom: 15px;
    }

    .download1 {
      padding: 40px 12px;
      background: #333;
      color: #fff;
      display: block;
      margin-bottom: 15px;
    }
  }
}
</style>







// WEBPACK FOOTER //
// src/views/report/three.vue